import { createStore, createActionsHook, createStateHook, createSelector } from 'react-sweet-state';

export enum LocalActivityAction {
	deleted = 'deleted',
	viewed = 'viewed',
}

export type DehydratedEvent = {
	id: string;
	action: LocalActivityAction;
	timestamp: string;
	content: {
		id?: string | null;
		__typename: 'Content';
	};
	__typename: 'LocalActivityEvent';
};

export const localActivityStore = createStore({
	name: 'localActivityStore',
	initialState: {
		localActivity: [] as DehydratedEvent[],
	},
	actions: {
		setLocalActivity:
			(localActivity: DehydratedEvent[]) =>
			({ setState }) => {
				setState({ localActivity: [...localActivity] });
			},
		getLocalActivity:
			() =>
			({ getState }) => {
				return getState().localActivity;
			},
	},
});

const localActivitySelector = createSelector(
	(state: any) => state.localActivity,
	(localActivity) => localActivity,
);
export const useLocalActivityCache = createStateHook(localActivityStore, {
	selector: localActivitySelector,
});

export const useLocalActivityCacheStoreActions = createActionsHook(localActivityStore);
